import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Card,
  CardActionArea,
  CardHeader,
  //CardMedia,
  Grid,
  TextField
} from '@material-ui/core';

import { setNewSOProducts } from 'redux/actions';
//import defaultProduct from 'assets/default-product.png';

const ProductsDisplay = ({soProducts, setNewSOProducts, ...props}) => {

  const [barcodeInput, setBarcodeInput] = useState("");

  const addProduct = (productInfo) => {
    const index = soProducts.findIndex(soProduct => soProduct.productId === productInfo.id);
    //if the product is already added to salesOrder, increase its quantity.
    if( index > -1 ) {
      setNewSOProducts([
        ...soProducts.slice(0, index),
        {
          ...soProducts[index],
          quantity: soProducts[index].quantity + 1
        },
        ...soProducts.slice(index + 1)
      ]);
    }
    //else add the product to the salesOrder
    else {
      setNewSOProducts([
        ...soProducts,
        {
          productId: productInfo.id,
          displayId: productInfo.displayId,
          name: productInfo.name,
          company: productInfo.company,
          unitPrice: productInfo.unitCost,
          quantity: 1
        }
      ]);
    }

    props.setCurrSubTotal(props.currSubTotal + productInfo.unitCost);
  };

  const checkProductBarcode = (e) => {
    setBarcodeInput(e.target.value);

    if(e.target.value.length > 3) {
      const productInfo = props.products.find(product => product.barcode === e.target.value);
      if(productInfo) {
        addProduct(productInfo);
        setBarcodeInput("");
      }
    }
  };

  return (
    <Box style={{ paddingRight: '16px' }}>
      <TextField
        style={{
          backgroundColor: '#ffffff',
          marginBottom: '14px'
        }}
        fullWidth
        label="Scan Product Barcode"
        name="barcode"
        onChange={(event) => checkProductBarcode(event)}
        value={barcodeInput}
        variant="outlined"
      />
      <Grid container spacing={2}>
        { props.products.map((product) => (
          <Grid item key={product.id} xs={6} sm={4} md={3} lg={2}>
            <Card
              style={{
                width: '100%',
                paddingBottom: '100%',
                position: 'relative'
              }}
            >
              <CardActionArea
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                onClick={() => addProduct(product)}
              >
                <CardHeader
                  style={{ textAlign: 'center', padding: '8px' }}
                  subheader={`${product.unitCost} AED`}
                  title={product.name}
                />
              </CardActionArea>
            </Card>
          </Grid>
        )) }
      </Grid>
    </Box>
  )
};

export default connect (null, {setNewSOProducts}) (ProductsDisplay);